import React, { useEffect, useMemo, useRef } from "react";
import { Alert, Button, Result, Space, Typography } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useAgentBillingStatus } from "../../../contexts/AgentBillingStatusContext";

const { Text } = Typography;

function normalizeStatus(rawStatus) {
  const status = String(rawStatus || "").trim().toLowerCase();
  if (status === "ok") return "ok";
  if (status === "cancelled" || status === "canceled") return "cancelled";
  if (status === "failed" || status === "error") return "failed";
  return "failed";
}

export default function PaymentMethodVaultReturn() {
  const location = useLocation();
  const navigate = useNavigate();
  const { reload } = useAgentBillingStatus();
  const refreshedRef = useRef(false);

  const params = useMemo(() => new URLSearchParams(location.search || ""), [location.search]);
  const status = normalizeStatus(params.get("status"));
  const paymentMethodId = String(params.get("paymentMethodId") || "").trim();
  const reason = String(params.get("reason") || "").trim();
  const flowType = String(params.get("flow_type") || "").trim();

  useEffect(() => {
    if (refreshedRef.current) return;
    refreshedRef.current = true;
    if (typeof reload === "function") {
      Promise.resolve(reload()).catch(() => {});
    }
  }, [reload]);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      navigate("/p/dashboard/home");
    }, 3000);
    return () => window.clearTimeout(timer);
  }, [navigate]);

  const onBackToDashboard = () => {
    navigate("/p/dashboard/home");
  };

  let resultStatus = "success";
  let title = "✅ אמצעי התשלום נשמר בהצלחה";
  let subtitle = "תועברו אוטומטית לדשבורד בעוד 3 שניות.";

  if (status === "cancelled") {
    resultStatus = "warning";
    title = "⚠️ הפעולה בוטלה";
    subtitle = "לא בוצעו שינויים באמצעי התשלום.";
  } else if (status === "failed") {
    resultStatus = "error";
    title = "❌ שמירת אמצעי התשלום נכשלה";
    subtitle = "ניתן לנסות שוב מהדשבורד.";
  }

  return (
    <div style={{ inlineSize: "100%", maxInlineSize: 760, margin: "24px auto", padding: "0 12px" }}>
      <Result
        status={resultStatus}
        title={title}
        subTitle={subtitle}
        extra={
          <Button type="primary" onClick={onBackToDashboard}>
            חזור לדשבורד
          </Button>
        }
      />

      <Space direction="vertical" style={{ inlineSize: "100%" }} size="middle">
        <Alert
          type={status === "ok" ? "success" : status === "cancelled" ? "warning" : "error"}
          message="סיכום חזרה מ-Vault"
          description={
            <Space direction="vertical" size={2}>
              <Text>status: {status}</Text>
              {paymentMethodId ? <Text>paymentMethodId: {paymentMethodId}</Text> : null}
              {reason ? <Text>reason: {reason}</Text> : null}
              {flowType ? <Text>flow_type: {flowType}</Text> : null}
            </Space>
          }
          showIcon
        />
      </Space>
    </div>
  );
}
